<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <b-field v-if="boys">
          <b-input v-model="searchName" placeholder="Search delivery boy in this city"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <a class="button full-width-button  is-primary" @click="openModal">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add</span>
          </a>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-3" v-for="boy in filterBy(boys, searchName)" :key="boy.docId">
        <div class="card">
          <div class="card-content">
            <div class="has-text-centered">
              <img class="boy-image" :src="boy.imageUrl || '/static/placeholder_image.png'" alt="Placeholder image">            
            </div>
            <div class="has-text-centered">
            <strong :title="boy.label">{{boy.name | truncate(20)}}</strong>
            <p>{{boy.contact}}</p> </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="openModal(boy)"> <b-icon type='is-primary' size="is-small" icon="edit"></b-icon></a>
            <b-upload class="card-footer-item" v-model="files" @input="uploadImage(boy)">
              <a>
                <b-icon type='is-info' size="is-small" icon="upload"></b-icon>
              </a>
            </b-upload>
            <a class="card-footer-item" @click="deleteBoy(boy)"><b-icon type='is-info' size="is-small" icon="trash"></b-icon></a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManageDeliveryBoy from './ManageDeliveryBoy';
import DeliveryBoysService from './service';
import UploadService from '../../../lib/UploadService';

export default {
  name: 'deliveryBoys',

  props: ['city'],

  created() {
    this.fetchDeliveryBoys();
  },

  data() {
    return {
      isLoading: true,
      boys: null,
      searchName: null,
      files: null
    };
  },

  methods: {
    fetchDeliveryBoys() {
      DeliveryBoysService.all(this.city).then(data => {
        this.boys = data;
        this.isLoading = false;
      });
    },

    deleteBoy(boyToBeDeleted) {
      this.$dialog.confirm({
        message: 'Sure to delete delivery boy?',
        onConfirm: () => {
          this.isLoading = true;

          DeliveryBoysService.deleteBoy(this.city, boyToBeDeleted).then(() => {
            this.boys = this.boys.filter(
              boy => boy.docId !== boyToBeDeleted.docId
            );
            this.isLoading = false;
            this.$toast.open('Delivery boy deleted successfully');
          });
        }
      });
    },

  openModal(boy = null) {
      this.$modal.open({
        parent: this,
        props: {
          boy,
          city: this.city
        },
        component: ManageDeliveryBoy,
        hasModalCard: true
      });
    },

    uploadImage(boy) {
      UploadService(
        this.files[0],
        `cities/${this.city.docId}/delivery-boys`,
        boy.docId
      )
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>

<style scoped>
.boy-image {
  height: 100px;
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/cities/DeliveryBoys/DeliveryBoys.vue